import type { Category } from "@CommonApi/categories";
import { omniAtom } from "src/utils/atoms";

export const importPdfSummaryExclusionsModalDataAtom = omniAtom<Category | null>({
  prefix: "src/modals/importPdfSummaryExclusions",
  key: "data",
  value: null,
});
